import { CT_CHAIN_ID, CT_TOKEN } from 'consts/copyTrading';
import { makeAutoObservable, reaction } from 'mobx';
import { CommonStore } from 'store/common/CommonStore';
import { Web3Store } from 'store/web3/Web3Store';
import { bn } from 'utils/BigNumber';
import { Address } from 'viem';

type CopyAction = 'deposit' | 'withdraw';

export class CopyFormStore {
  copyAction: CopyAction = 'deposit';
  value = '';
  walletsToCopy: Address[] = [];

  isCopyModalOpen = false;
  isSubmitting = false;

  constructor(
    private web3: Web3Store,
    private commonStore: CommonStore
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    reaction(
      () => this.copyAction,
      () => {
        this.setValue('');
      }
    );

    reaction(
      () => this.isCopyModalOpen,
      () => {
        if (!this.isCopyModalOpen) {
          this.walletsToCopy = [];
        }
      }
    );
  }

  get tokenInAddress() {
    return CT_TOKEN.address;
  }

  get tokenIn() {
    return CT_TOKEN;
  }

  setValue = (value: string) => {
    const isValueChanged = !bn(this.value).eq(value);
    if (isValueChanged) {
      this.value = value;
    }
  };

  get isNoValue() {
    return !this.value || +this.value === 0 || bn(this.value).isNaN();
  }

  get inputInDollars() {
    if (!this.value || this.isNoValue || !this.tokenIn) {
      return null;
    }
    if (this.tokenIn.symbol === 'USDC' || this.tokenIn.symbol === 'USDC.e') {
      return bn(this.value).toFixed(2, bn.ROUND_DOWN);
    }
    const tokenInPrice = this.commonStore.pricesMap[CT_CHAIN_ID]?.[CT_TOKEN.address];
    if (!tokenInPrice) return;
    const valueInDollars = bn(this.value).mul(tokenInPrice).toFixed(2, bn.ROUND_DOWN);
    return valueInDollars;
  }

  setIsSubmitting = (isSubmitting: boolean) => {
    this.isSubmitting = isSubmitting;
  };

  openCopyModal = (action: CopyAction = 'deposit', walletsToCopy?: Address[]) => {
    this.copyAction = action;
    this.walletsToCopy = walletsToCopy || [];
    this.isCopyModalOpen = true;
  };

  closeCopyModal = () => {
    this.isCopyModalOpen = false;
    this.walletsToCopy = [];
  };

  setCopyAction = (copyAction: CopyAction) => {
    this.copyAction = copyAction;
  };

  setWalletsToCopy = (wallets: Address[]) => {
    this.walletsToCopy = wallets;
  };
}
